import {
  ValidateDiscountCodeResponse,
  WarrantyPackage,
} from "shared/api/middleware-api-client";
import { proxy } from "valtio";

type voucherStateType = {
  voucher: ValidateDiscountCodeResponse | null;
  orderWarrantyPackages: WarrantyPackage[] | null;
};
export const voucherState = proxy<voucherStateType>({
  voucher: null,
  orderWarrantyPackages: null,
});

export const setStateVoucher = (voucher: ValidateDiscountCodeResponse) => {
  voucherState.voucher = voucher;
};

export const clearVoucher = () => {
  voucherState.voucher = null;
};

export const setOrderWarrantyPackages = (packages: WarrantyPackage[]) => {
  voucherState.orderWarrantyPackages = packages;
};
// export const getRawVoucher = (totalPrice: number): number => {
//   const v = voucherState.voucher;
//   if (!v) return 0;
//   return v.type === "abs" ? v.value : totalPrice * (v.value / 100);
// };

// export const getVoucherDisplay = (): string => {
//   const v = voucherState.voucher;
//   if (!v) return "";
//   return v.type === "abs" ? `${v.value} euro` : `${v.value}%`;
// };
